import store from '@/store'

export default {
  install: (app, options) => {
    app.config.globalProperties.$copyClipboard = (data) => {
			let dummy = document.createElement('input')
      document.body.appendChild(dummy)
      dummy.value = data
      dummy.select()
      document.execCommand('copy')
      document.body.removeChild(dummy)

      store.dispatch('createNotification', { title: 'Done', message: `"${data}" has been copied successfully!` })
    }
  }
}